import React, { useEffect, useState } from 'react';
import { getSmsStats } from '../../services/SmsService';

function SmsStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchStats() {
      setLoading(true);
      setError(null);
      try {
        const data = await getSmsStats();
        setStats(data);
      } catch (err) {
        setError('Failed to load stats');
      }
      setLoading(false);
    }
    fetchStats();
  }, []);

  if (loading) return <div className="mb-4">Loading stats...</div>;
  if (error) return <div className="alert alert-danger mb-4">{error}</div>;
  if (!stats) return null;

  return (
    <div className="row g-3 mb-4">
      <div className="col-12 col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-secondary mb-2"><i className="bi bi-send"></i> PROCESSED SMS</div>
            <div className="display-5 fw-bold text-dark">{stats.totalSentSmsCount || 0}</div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-secondary mb-2"><i className="bi bi-check-circle"></i> DELIVERED SMS</div>
            <div className="display-5 fw-bold text-dark">{stats.totalDeliveredSmsCount || 0}</div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-secondary mb-2"><i className="bi bi-x-circle"></i> FAILED SMS</div>
            <div className="display-5 fw-bold text-dark">{stats.totalFailedSmsCount || 0}</div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-secondary mb-2"><i className="bi bi-clock"></i> UNDELIVERED SMS</div>
            <div className="display-5 fw-bold text-dark">{stats.totalUndeliveredSmsCount || 0}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmsStats; 